module.exports = __webpack_public_path__ + "images/d68c20540f958b6fc572f1fe165bff32-desk2.jpg";